import { createSelector } from 'reselect';
export const getProductPreviewState = (state) => state.productPreview;
export const makeGetShowImageTouchZoomHint = () => createSelector(getProductPreviewState, (productPreviewState) => productPreviewState.imageTouchZoomHint);
